import api from './api';
import type { WineListItemFormat, WineListItemFormatVisibility } from '../types/venue';

const base = (venueId: string, itemId: string) =>
  `/admin/venue/${venueId}/wine-list-item/${itemId}/formats`;

export interface CreateItemFormatPayload {
  formatId: string;
  price: number;
  visibility?: WineListItemFormatVisibility;
}

export interface UpdateItemFormatPayload {
  price?: number;
  visibility?: WineListItemFormatVisibility;
}

const wineListItemFormatService = {
  /** List every format pricing on an item. The GET response embeds the format catalog object under formatId. */
  getItemFormats: async (venueId: string, itemId: string): Promise<WineListItemFormat[]> => {
    const response = await api.get(base(venueId, itemId));
    return response.data;
  },

  createItemFormat: async (
    venueId: string,
    itemId: string,
    data: CreateItemFormatPayload,
  ): Promise<WineListItemFormat> => {
    const response = await api.post(base(venueId, itemId), data);
    return response.data;
  },

  updateItemFormat: async (
    venueId: string,
    itemId: string,
    itemFormatId: string,
    data: UpdateItemFormatPayload,
  ): Promise<WineListItemFormat> => {
    const response = await api.patch(`${base(venueId, itemId)}/${itemFormatId}`, data);
    return response.data;
  },

  deleteItemFormat: async (
    venueId: string,
    itemId: string,
    itemFormatId: string,
  ): Promise<void> => {
    await api.delete(`${base(venueId, itemId)}/${itemFormatId}`);
  },
};

export default wineListItemFormatService;
